"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _autolinker = _interopRequireDefault(require("autolinker"));

var once = function once(func) {
  var alreadyCalled = false;
  var result;
  return function () {
    if (!alreadyCalled) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      result = func.apply(this, args);
      alreadyCalled = true;
    }

    return result;
  };
};

var _default = {
  get: once(function () {
    return new _autolinker.default({
      stripPrefix: false
    });
  }),
  getTwitter: once(function () {
    return new _autolinker.default({
      hashtag: 'twitter',
      mention: 'twitter',
      stripPrefix: false
    });
  })
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/sanitizers/Autolinker.js
// module id = 807
// module chunks = 209 210 211 212